import { useCallback } from "react";

import useAnalytics from "@/hooks/use-analytics";

import type { CartType } from "../types";

export default function useTrackCartEvent() {
  const { track: trackEvent } = useAnalytics();

  const track = useCallback(
    // biome-ignore lint/suspicious/noExplicitAny: legacy
    (event: string, cart: CartType, extra?: Record<string, any>) => {
      trackEvent(event, {
        ...extra,
        cart_id: cart.id,
        company_id: cart.timeslot.game.location.company.id,
        company_name: cart.timeslot.game.location.company.name,
        discount: cart.discount,
        game_id: cart.timeslot.game.id,
        game_name: cart.timeslot.game.name,
        inconvenience_fee: cart.inconvenienceFee,
        items: cart.items.map(({ vendorCategoryId, quantity }) => ({
          quantity,
          vendor_category_id: vendorCategoryId,
        })),
        location_id: cart.timeslot.game.location.id,
        promotions: cart.promotions.map(({ code, isActive, kind, amount }) => ({
          amount,
          code,
          is_active: isActive,
          kind,
        })),
        quantity: cart.items.reduce((acc, { quantity }) => acc + quantity, 0),
        subtotal: cart.subtotal,
        tax: cart.tax,
        timeslot_date: cart.timeslot.datetime,
        timeslot_id: cart.timeslot.id,
        total: cart.total,
      });
    },
    [trackEvent]
  );

  return track;
}
